module.exports = "<template>\n    <div>\n        <vbl-radio v-model=\"val\" native-value=\"0\">香蕉</vbl-radio>\n        <vbl-radio v-model=\"val\" native-value=\"1\">苹果</vbl-radio>\n        <vbl-radio v-model=\"val\" native-value=\"2\" disabled>禁用</vbl-radio>\n        \n        <br/>\n        <br/>\n        {{val}}\n    </div>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                val: '0'\n            };\n        }\n    }\n</script>"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/vblRadio/example/vblRadioExample.vue
// module id = 175
// module chunks = 0